import { HoursPipe } from '../../shared/pipes/hours.pipe'

export function hours ( hoursPipe : HoursPipe ) {
  return ( value : number ) : string | number => hoursPipe.transform(value);
}
